import React, { useEffect } from 'react';
import Confetti from 'react-confetti';
import './Bonus.scss';

const BonusBravo = ({ anecdote, onContinue, disabled }) => {
    const texteAttente = "L'anecdote liée à cette question arrivera bientôt dans la prochaine mise à jour de notre base de données !";

    // Déclenchement du son à l'ouverture de la modale
    useEffect(() => {
        const audio = new Audio('/Sound/applaudissement.mp3');
        audio.volume = 0.5; // Ajuste le volume entre 0.0 et 1.0
        audio.play().catch(error => {
            console.log("Lecture du son bloquée par le navigateur :", error);
        });
    }, []);

    return (
        <div className="modal-overlay">
            
            {/* Pluie de 500 confettis qui s'arrête d'elle-même */}
            <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                recycle={false} 
                numberOfPieces={500} 
                gravity={0.15}
            />

            <div className="bonus-modal">
                <div className="bonus-header">
                    <h2>
                        Bravo !<br />
                        C'est un sans faute !
                    </h2>
                    <p className="points-text">Tu comptabilises 180 points !</p>
                    <p className="hero-text">Retour à la maison en HERO !</p>
                </div>
                
                <div className="anecdote-box">
                    <h3>💡 Le savais-tu ?</h3>
                    <p>{anecdote ? anecdote : texteAttente}</p>
                </div>

                {onContinue && (
                    <button className="continue-button" onClick={onContinue} disabled={disabled}>
                        {disabled ? "En attente..." : "Continuer en HÉRO !"}
                    </button>
                )}
            </div>
        </div>
    );
};

export default BonusBravo;